var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#807D7D",
    strokeWidth: 1.5,
    clipPath: "url(#compass_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.335 10a8.333 8.333 0 1 0-16.667 0 8.333 8.333 0 0 0 16.667 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.333 6.915 2.433-.811c.739-.246 1.108-.37 1.303-.174.195.195.072.564-.174 1.302l-.811 2.434c-.42 1.258-.63 1.887-1.08 2.339-.452.45-1.081.66-2.34 1.08l-2.433.811c-.739.246-1.108.37-1.303.174-.195-.194-.072-.564.175-1.302l.81-2.434c.42-1.258.63-1.887 1.081-2.338s1.08-.661 2.34-1.081M10.001 10l-.005.005"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compass_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCompass;